<div class="dialog-component">
  <div class="cross">
    <button id="desktop-focus-agegroup" tabindex="0" type="button" class="close close-btn" aria-label="Close"
    (click)="dialogData.reset()"></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button id="mob-focus-agegroup" tabindex="0" type="button" class="close close-btn" aria-label="Close"
      (click)="dialogData.reset()"></button>
    </div>

    <div class="dialog-body">
      <label id="ageGroupLabel" for="age-group-options" class="age-group-label">Which age groups do you intend to
      referee?</label>
      @if (dialogData.ageGroupError && !dialogData.selectedAgeGroup) {
        <div role="alert" aria-label="error" class="page-error">
          <label for="age-group">Please confirm the age group you wish to referee</label>
        </div>
      }
      <div class="modal-genderbody-content edit-other-phone-modal">
        <form #myAgeGroupForm="ngForm">
          <div role="radiogroup" aria-label="Gender">
            <div class="modal-form-group radio-wrapper">
              <input type="radio" tabindex="0" name="age-group" [(ngModel)]="dialogData.selectedAgeGroup" id="Adult"
                value="1" aria-label="Adult" ngModel />
                <label for="Adult">Open age (Adult)</label>
              </div>
              <div class="modal-form-group radio-wrapper">
                <input type="radio" tabindex="0" name="age-group" [(ngModel)]="dialogData.selectedAgeGroup" id="Youth"
                  value="2" aria-label="Youth" ngModel />
                  <label for="Youth">Youth only (Under 18)</label>
                </div>
                <div class="modal-form-group radio-wrapper">
                  <input type="radio" tabindex="0" name="age-group" [(ngModel)]="dialogData.selectedAgeGroup" id="openAge"
                    value="3" aria-label="openAge" ngModel />
                    <label for="openAge">Adult & Youth (All age groups)</label>
                  </div>
                </div>

                @if (dialogData.selectedAgeGroup == '2' || dialogData.selectedAgeGroup == '3') {
                  <div class="info-container">
                    <div class="flex">
                      <div class="info-icon"></div>
                      <p>An email will be sent to you to start the DBS process, email: <strong>{{
                      dialogData.sharedService.email }}</strong></p>
                    </div>
                  </div>
                }

                @if (dialogData.selectedAgeGroup == '1') {
                  <div class="info-container warning">
                    <div class="flex">
                      <div class="warning-info-icon"></div>
                      <p>A DBS is not required to referee adult football</p>
                    </div>
                  </div>
                }

                <div>
                  <div class="btn-container">
                    <button tabindex="0" aria-label="save" class="send-button" (click)="dialogData.initiateDbs()"
                      (keydown.enter)="dialogData.initiateDbs()" (keydown.space)="dialogData.initiateDbs()">
                      {{ dialogData.selectedAgeGroup == '1' ? 'Ok, Got it' : 'Confirm' }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>